import React from 'react'

import { t } from '@/i18n'

import { useSearch } from '../SearchContext'
import TBody from './TBody'

const SearchResult: React.FC = () => {
  const { searchRes } = useSearch()

  if (!searchRes.length) return null
  return (
    <div className="live-results">
      <div className="table-box">
        <table>
          <thead>
            <tr>
              <td>
                <span className="icon-car"></span>
                {t('cars')}
              </td>
              <td>
                <span className="icon-incandescent"></span>
                {t('deals')}
              </td>
              <td>
                <span className="icon-file"></span>
                {t('invoices')}
              </td>
              <td>
                <span className="icon-reports"></span>
                {t('reports')}
              </td>
              <td>
                <span className="icon-briefcase"></span>
                {t('proposals')}
              </td>
              <td>
                <span className="icon-customer"></span>
                {t('customer')}
              </td>
            </tr>
          </thead>
          <TBody data={searchRes} />
        </table>
      </div>
    </div>
  )
}

export default SearchResult
